import Script from 'next/script'
import React from 'react'
import PropTypes from 'prop-types'
import configData from '../../../config';
import { customJsonstringify } from '../../../utils/helpers/customJsonstringify.helpers';

const GtmScriptFunction = (props) => {
    const { interval = 3.5 } = props
    // Use customJsonstringify to HTML-escape the data (query string is attacker-controllable via router.asPath), preventing </script> breakout / DOM-based XSS.
    const scriptString = `
    var PGdataLayer = ${customJsonstringify(props.dataObject)};
    var timer=${interval}
    if (document.readyState !== "loading") {
            setTimeout(initGTM, timer*1000); 
        } else { 
            document.addEventListener('DOMContentLoaded', function() {
             setTimeout(initGTM, timer*1000); 
            });
        }
      document.addEventListener('scroll', initGTMOnEvent);
      document.addEventListener('mousemove', initGTMOnEvent);
      document.addEventListener('touchstart', initGTMOnEvent);
      function initGTMOnEvent(event) {
        initGTM();
        event.currentTarget.removeEventListener(event.type, initGTMOnEvent); 
      }
    function initGTM() {
        if (window.gtmDidInit) {
            return false;
        }  
        console.info("Mounting GTM")
        window.gtmDidInit = true ;
        (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            let f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
            j.setAttribute("defer", "");
            j.async=true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "${configData.tagManagerId}");
    }
`
    return (
        <>
            <Script
                strategy='afterInteractive'
                dangerouslySetInnerHTML={{
                    __html:scriptString,
                }}
            />
        </>
    )
}
GtmScriptFunction.propTypes = {
    interval: PropTypes.number,
}

export default GtmScriptFunction

